export const CONNECT = [
	// ensure navigator-context misc dep is loaded before navigator-context
	'wr!confluence.web.resources:querystring',
	// resource to provide the context value of AP.navigator.getLocation
	'wr!confluence.web.resources:navigator-context',
	'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5',
];

export const EDITOR_LOADER = [
	...CONNECT,
	'wr!confluence.web.resources:breadcrumbs',
	'wr!com.atlassian.confluence.plugins.editor-loader:background-loading-editor',
	'wr!com.atlassian.confluence.plugins.quickedit:quick-edit-general',
	'wr!com.atlassian.confluence.plugins.quickedit:quick-comment-initial',
];

export const CONFLUENCE_PREVIEWER = ['wrc!media-viewer'];

export const CONFLUENCE_SPACE_IA = [
	'wr!com.atlassian.confluence.plugins.confluence-space-ia:link-dialog',
	'wr!com.atlassian.confluence.plugins.confluence-link-browser:link-browser',
	'wr!com.atlassian.confluence.plugins.confluence-link-browser:linkbrowser-css-resources',
];

/**
 * This fetches atlassian-connect resources from the AC plugin.
 * Only v5 resources - it should be close to 100% rollout now. v3 is no longer supported by the editor.
 */
export const ACv5 = [
	...CONNECT,
	// atlassian-plugin-confluence.xml
	'wr!com.atlassian.plugins.atlassian-connect-plugin:dynamic-css-resources',
	'wr!com.atlassian.plugins.atlassian-connect-plugin:featured-macro-css-resources',
	// atlassian-plugin-confluence-jsapi-v5.xml
	'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-autoconvert-resources-v5',
	'wr!com.atlassian.plugins.atlassian-connect-plugin:macro-editor-resources-v5',
];
